// Sidebar.js
import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaChartBar,
  FaPlus,
  FaBullhorn,
  FaUserFriends,
  FaIdCard,
  FaCog,
  FaBuilding,
  FaShieldAlt,
  FaIndustry,
} from "react-icons/fa";

const Sidebar = () => {
  const location = useLocation();
  console.log("Current location in sidebar:", location.pathname);

  const isActive = (path) => {
    // Handle the dashboard case specifically
    if (
      path === "/dashboard" ||
      (path === "" && location.pathname.endsWith("/ai-sdr"))
    ) {
      return (
        location.pathname.endsWith("/dashboard") ||
        location.pathname.endsWith("/ai-sdr")
      );
    }
    // Handle other paths
    return location.pathname.endsWith(path);
  };

  const menuItems = [
    {
      path: "/dashboard",
      label: "Dashboard",
      icon: <FaChartBar />,
    },
    {
      path: "/campaign-builder",
      label: "Campaign Builder",
      icon: <FaPlus />,
    },
    {
      path: "/campaigns",
      label: "Campaigns",
      icon: <FaBullhorn />,
    },
    {
      path: "/leads",
      label: "Leads",
      icon: <FaUserFriends />,
    },
    {
      path: "/companies",
      label: "Companies",
      icon: <FaBuilding />,
    },
    {
      path: "/generators",
      label: "Generators",
      icon: <FaIndustry />,
    },
    {
      path: "/personas",
      label: "Personas",
      icon: <FaIdCard />,
    },
    {
      path: "/blacklist-checker",
      label: "Blacklist Checker",
      icon: <FaShieldAlt />,
    },
    {
      path: "/settings",
      label: "Settings",
      icon: <FaCog />,
    },
  ];

  return (
    <aside className="w-64 bg-gradient-to-b from-blue-400 to-blue-300 text-white p-4 flex flex-col h-screen sticky top-0">
      {/* Logo */}
      <div className="mb-8 text-center">
        <Link to="/ai-sdr">
          <div className="flex items-center justify-center">
            <h1 className="text-3xl font-bold">AiSDR</h1>
          </div>
        </Link>
      </div>

      {/* Navigation */}
      <nav className="flex-1">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={`/ai-sdr${item.path}`}
                className={`
                  flex items-center px-4 py-3 rounded-lg transition-colors
                  ${
                    isActive(item.path)
                      ? "bg-white text-blue-500 font-semibold"
                      : "text-white hover:bg-blue-500"
                  }
                `}
              >
                <span className="mr-3 text-xl">{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* Version or user info */}
      <div className="mt-auto text-center p-4 text-sm text-blue-100">
        <div className="flex items-center justify-center mb-1">
          <div className="bg-white rounded-full h-8 w-8 flex items-center justify-center text-blue-500 mr-2">
            <span className="font-bold">Y</span>
          </div>
        </div>
        <div>Version 1.0.0</div>
      </div>
    </aside>
  );
};

export default Sidebar;
